import React, { useContext, useEffect } from 'react'
import { getImages } from '../Components/const'
import FeaturedVehicles from '../Components/Home/FeaturedVehicles'
import HomeVideo from '../Components/Home/HomeVideo'
import Facilities from '../Components/Home/Facilities'
import HomeAward from '../Components/Home/HomeAward'
import AwardWining from '../Components/Home/AwardWining'
import HomeAbout from '../Components/Home/HomeAbout'
import HomeLocation from '../Components/Home/HomeLocation'
import JoinMclearn from '../Components/Home/JoinMclearn'
import UseScrollReveal from '../Components/Common/UseScrollReveal '
import { VehicleContext } from '../Components/Context/VehicleContext'
import JoinMailing from '../Components/Home/JoinMailing'
import SeoMeta from '../Components/Common/SeoMeta'

const Home = () => {
    const { getVehicleData, filteredVehicleData, numberFormatter, priceFormatter } = useContext(VehicleContext);
    useEffect(() => {
        getVehicleData();
    }, []);
    return (
        <>
            <SeoMeta
                title="Official McLaren Dealership In Orlando FL | New & Pre-Owned McLaren"
                description="Official McLaren dealership in Orlando, FL. McLaren Orlando is the top McLaren Dealer destination for New & Pre-Owned McLaren For Sale."
                keywords=""
                ogTitle="Official McLaren Dealership In Orlando FL | New & Pre-Owned McLaren"
                ogDescription="Official McLaren dealership in Orlando, FL. McLaren Orlando is the top McLaren Dealer destination for New & Pre-Owned McLaren For Sale."
            />
            <HomeVideo />
            <HomeAward />
            <Facilities />
            {filteredVehicleData &&
                <FeaturedVehicles 
                    featuredVehicles={filteredVehicleData.filter((item) => item.inventory_manage.featured)} 
                    numberFormatter={numberFormatter} 
                    priceFormatter={priceFormatter} 
                />
            }
            <AwardWining />
            <HomeAbout />
            <HomeLocation />
            <JoinMclearn />
            <JoinMailing/>
        </>
    )
}

export default Home